<template lang="pug">
  b-modal#addProxy(
  ref="addProxy"
  :title="$t('ui.combine.add_proxy')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.proxy_host')").mb-0
        DebounceInput(
          ref="dataAdd_proxyHost"
          size="sm"
          required
          type="text"
          :dirty="$v.dataAdd_proxyHost.$dirty"
          :error="$v.dataAdd_proxyHost.$error"
          v-model.trim.lazy="$v.dataAdd_proxyHost.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_proxyHost.$params.maxLength.max"
        ) 
        ValidateResult(:value="$v.dataAdd_proxyHost" :name="$t('ui.proxy_host')")
      b-form-group(:label="$t('ui.proxy_port')").mb-0
        DebounceInput(
          ref="dataAdd_proxyPort"
          size="sm"
          type="text"
          :dirty="$v.dataAdd_proxyPort.$dirty"
          :error="$v.dataAdd_proxyPort.$error"
          v-model.trim.lazy="$v.dataAdd_proxyPort.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_proxyPort.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_proxyPort" :name="$t('ui.proxy_port')")
      b-form-group(:label="$t('ui.proxy_remark')").mb-0
        DebounceInput(
          ref="dataAdd_proxyRemark"
          size="sm"
          type="text"
          :dirty="$v.dataAdd_proxyRemark.$dirty"
          :error="$v.dataAdd_proxyRemark.$error"
          v-model.trim.lazy="$v.dataAdd_proxyRemark.$model"
          :disabled="loading"
        )
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      dataAdd_proxyHost: "",
      dataAdd_proxyPort: "",
      dataAdd_proxyRemark: "",
      loading: false,
      feedback: {
        success: true,
        status: "",
        proxy_id: ""
      },
    };
  },
  validations: {
    dataAdd_proxyHost: {
      required,
      maxLength: maxLength(255)
    },
    dataAdd_proxyPort: {
      maxLength: maxLength(255)
    },
    dataAdd_proxyRemark:{
      maxLength: maxLength(255)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addProxyUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.proxy,
          proxy_host: this.dataAdd_proxyHost,
          proxy_port: this.dataAdd_proxyPort,
          remark: this.dataAdd_proxyRemark
        };
        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                this.feedback.proxy_id = response.data.proxy_id;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.feedback.proxy_id, this.dataAdd_proxyHost, this.dataAdd_proxyPort, this.dataAdd_proxyRemark);
                  this.$refs.addProxy.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_proxy", this.feedback.status);
                  this.$refs.addProxy.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.dataAdd_proxyHost = "";
      this.dataAdd_proxyPort = "";
      this.dataAdd_proxyRemark = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataAdd_proxyHost.$el.focus();
    }
  }
};
</script>
